export const getReservationCode = (ticket) => {
	if (ticket) {
		return `RV${ticket.id.toString().trim().substr(-3)}`;
	}
	return null;
};
